import { api } from "./api";

export const pushSupported = () => window.isSecureContext && "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

export async function disableBrowserPush() {
  if (!pushSupported()) return;
  const registration = await navigator.serviceWorker.getRegistration("/");
  const subscription = await registration?.pushManager.getSubscription();
  if (subscription) {
    await api.delete("/push/subscribe", { data: { endpoint: subscription.endpoint } });
    await subscription.unsubscribe();
  }
}

export async function enableBrowserPush() {
  if (!pushSupported()) throw new Error("This browser does not support push notifications.");
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("Notifications are blocked. You can allow them in your browser's site settings. Email and in-app alerts still work.");
  await navigator.serviceWorker.register("/push-sw.js", { scope: "/" });
  const registration = await navigator.serviceWorker.ready;
  const { data } = await api.get("/push/public-key");
  const key = Uint8Array.from(atob(data.public_key.replace(/-/g, "+").replace(/_/g, "/") + "=".repeat((4 - data.public_key.length % 4) % 4)), (char) => char.charCodeAt(0));
  let subscription = await registration.pushManager.getSubscription();
  const isNew = !subscription;
  if (!subscription) subscription = await registration.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: key });
  try { await api.post("/push/subscribe", subscription.toJSON()); }
  catch (e) { if (isNew) await subscription.unsubscribe(); throw e; }
}
